export default function formatName(person, formatParts) {
  if (!person) {
    return '';
  }
  const {
    firstName,
    lastName
  } = person;
  return formatNameWithParts(firstName, lastName, formatParts);
}
export function formatNameWithParts(first, last, formatParts) {
  if (first) {
    return last ? formatParts(first, last) : first;
  } else {
    return last ?? '';
  }
}